import { DataFeedMapper } from 'modules/campaigns/lib/types';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { useRestQuery } from 'utils/hooks/api';
import { FETCH_FEEDS_URL } from 'api/TemplateEditAPI';

/*
 * Once we consolidate the contexts for campaign and templates, we could move the consumer of this hook to a context so that we only fetch this data once.
 */
export const useDataFeedsQuery = () => {
  const dispatch = useDispatch();
  const { data: response = { data: {} } } = useRestQuery<{ data: DataFeedMapper }>(
    FETCH_FEEDS_URL,
    {},
    {
      retry: false,
      refetchOnWindowFocus: false,
      onError: (e) => {
        dispatch(addNegativeToastWithErrorId('Unable to fetch data feed', 'useDataFeedsQuery', e));
      },
    },
  );

  return response.data;
};
